export default {
  label: "Label",
  summary: "Summary",
  propertyValues: "Text Properties",
  displayId: "ID"
};
